/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { BlogConfigFragment, HeroArticleImageFragment } from "@cosmos/hygraph-schema";

import {
	Animate,
	ArticleChildrenWrap,
	BlurredImage,
	CosmosAsset,
	ResponsiveContainer,
	SectionContainer,
} from "@components/elements";
import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";

import { HeroArticleImageMainStack } from "./HeroArticleImage.MainStack";

const styles = css({
	overflowX: "clip",
});

const blurredImage = css({
	"&&": {
		position: "absolute",
		w: "1200px",
		h: "300px",
		transform: "translate(28vw, -200px) translateZ(0)",
	},
});

const backgroundStyles = css({
	position: "absolute",
	top: 0,
	w: "full",
	h: "600px",
	"& img, & video": {
		w: "full",
		h: "full",
		objectFit: "cover",
	},
});

const backgroundGradient = css({
	position: "absolute",
	top: 0,
	w: "full",
	h: "full",
	background: "linear-gradient(180deg, rgba(16, 16, 20, 0.00) 0%, rgba(16, 16, 20, 0.50) 27.75%, #101014 92.5%)",
});

export interface HeroArticleImageProps extends HeroArticleImageFragment {
	blogConfig?: BlogConfigFragment | null;
}

export const HeroArticleImage = (props: HeroArticleImageProps | null): React.JSX.Element => {
	const validBackground = Boolean(props?.backgroundAsset?.url);

	return (
		<div className={cx("hero-article-image", styles)}>
			{validBackground ? (
				<div className={cx("hero-article-background", backgroundStyles)}>
					<CosmosAsset asset={props?.backgroundAsset} eager />
					<div className={backgroundGradient} />
				</div>
			) : null}
			<ResponsiveContainer>
				<SectionContainer disablePaddingBlockEnd>
					{!validBackground ? (
						<Animate delay={0.25} type="fade">
							<BlurredImage className={blurredImage} image={props?.asset} width={1200} height={676} opacity={0.6} />
						</Animate>
					) : null}
					<VStack gap="eds.dimension.64">
						<ArticleChildrenWrap>
							<Animate delay={0.25} type="slideLeft">
								<HeroArticleImageMainStack
									authorTag={props?.blogConfig?.authorTag}
									blogCategory={props?.blogConfig?.categories[0]}
									publicationDate={props?.blogConfig?.publicationDate}
									title={props?.title}
									description={props?.description}
									buttons={props?.buttons}
									tags={props?.blogConfig?.tags}
									gradient={props?.gradient}
								/>
							</Animate>
						</ArticleChildrenWrap>
						<ArticleChildrenWrap size="md">
							<Animate delay={0.4} type="slideLeft">
								<VStack justifyContent="center">
									<CosmosAsset asset={props?.asset} className={css({ borderRadius: "eds.dimension.24" })} eager />
								</VStack>
							</Animate>
						</ArticleChildrenWrap>
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</div>
	);
};
